module.exports = __webpack_public_path__ + "img/ot-usdc_eth_slp.bb77cae4.svg";